import React from "react";
import "./Quiz.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { click } from "@testing-library/user-event/dist/click";

const Quiz = ({ question }) => {
  const { options, correctAnswer } = question;
  const handleOption = (check) => {
    if (check === correctAnswer) {
      toast.success("Correct Answer!", {
        position: "top-center",
        closeOnClick: true,
        autoClose: 2000,
      });
    } else {
      toast.error("Ops! Wrong Answer", {
        autoClose: 2000,
      });
    }
  };
  const handleEye = () => {
    toast.success(correctAnswer);
  };
  return (
    <div>
      <div className="bg-white rounded-full w-8 text-center relative  eye-container ">
        <FontAwesomeIcon
          onClick={() => handleEye()}
          icon={faEye}
        ></FontAwesomeIcon>
      </div>
      <div className="custom-quiz">
        {question.options.map((option) => (
          <div className="flex border border-sky-400 p-4 rounded-lg bg-slate-100 hover:bg-sky-200  option-border">
            <div>
              <input
                onClick={() => handleOption(option)}
                type="radio"
                value={option}
                name="quiz"
                className="mr-2"
              />
            </div>
            <div className="options" key={option.id}>
              {option}
            </div>
          </div>
        ))}
      </div>
      <ToastContainer position="top-center" />
    </div>
  );
};

export default Quiz;
